import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

const Logout = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // remove token
    localStorage.removeItem("token");

    // redirect to login
    navigate("/");
  }, [navigate]);

  return null;
};

export default Logout;
